var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HostCards',{ref:"component",attrs:{"container":_vm.entity,"header":""},on:{"input":_vm.onInput},model:{value:(_vm.$attrs.value),callback:function ($$v) {_vm.$set(_vm.$attrs, "value", $$v)},expression:"$attrs.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }